import React from 'react'
import { Container, Grid } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useHtmlBlock } from './HtmlBlock.hooks'
import { COLUMN_WIDTH, SM_WIDTH } from './HtmlBlock.const'

const HtmlBlock = props => {
	const [
		{ classes, text, textConfig, fullWidth, containerWidth, parsedHtml, textEditable, textKey, key },
		{ handleTextClick, handleTextChange },
	] = useHtmlBlock(props)

	return (
		<>
			<EditableContainer
				visible={!!text}
				fieldConfig={textConfig}
				onAdd={handleTextChange}
				editable={textEditable}
				wrapper={({ children }) => <Container>{children}</Container>}
			>
				<EditableHTML
					key={textKey}
					className={clsx(classes.text, 'html-text-block-title')}
					html={text}
					editable={textEditable}
					onClick={handleTextClick}
					onChange={handleTextChange}
				/>
			</EditableContainer>
			<Container key={key} className="html-block" maxWidth={fullWidth ? false : 'lg'} disableGutters={fullWidth}>
				{fullWidth ? (
					parsedHtml
				) : (
					<Grid container className={clsx(classes.container, 'html-container')} justify="center">
						<Grid
							item
							xs={12}
							sm={SM_WIDTH[containerWidth]}
							md={COLUMN_WIDTH[containerWidth]}
							className="html-content"
						>
							{parsedHtml}
						</Grid>
					</Grid>
				)}
			</Container>
		</>
	)
}

export default HtmlBlock
